import { useLottie } from 'lottie-react';
import { createPage, Block, Content, Title, Flex, Container } from 'react-commons';
import Meta from '@/components/Meta';
import shockwaveDudeAnimation from '@/lib/lottie/shockwaveDude.json';
import FluidLayout from '@/layouts/FluidLayout';
import ModernAppFooter from '@/components/ModernAppFooter';
import MaintenancePageHeader from '@/components/MaintenancePageHeader';

import style from './index.module.scss';

export interface MaintenancePageProps {
}

export default createPage<MaintenancePageProps>('MaintenancePage', { style }, function MaintenancePage ({ className }) {
  const { View: LottieAnimation } = useLottie({
    animationData: shockwaveDudeAnimation,
    loop: true
  });

  return (
    <FluidLayout className={className} headless>

      {/* Meta information */}
      <Meta 
        title='Shockwave Games'
        titleTag='Shockwave Games'
      />

      <MaintenancePageHeader />
 
      <Container>
        <div className='MaintenancePage__Inner'>
          <Block>
            <Content className='--textCenter'>
              <Title h2 size5>Sorry about that!</Title>
              <p>Shockwave is currently down for maintenance. We'll be back soon!</p>
            </Content>
          </Block>
          <Block>
            <Flex alignCenter justifyCenter wide>
              <div className='MaintenancePage__Lottie'>
                {LottieAnimation}
              </div>
            </Flex>
          </Block>
        </div>
      </Container>

      <ModernAppFooter hideLinks />

    </FluidLayout>
  );
});
